module.exports = __webpack_public_path__ + "front/img/m_top.58df7700.png";